<script setup lang="ts">
import { i18n } from '@/i18n';
import { computed } from 'vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    direction: 'shortage' | 'excess';
    consecutiveMonths: string;
    ratioThreshold: string;
    defaultValueString?: string;
  }>(),
  { defaultValueString: undefined }
);
const emits = defineEmits(['update:consecutiveMonths', 'update:ratioThreshold']);

const title = computed(() => (props.direction === 'excess' ? 'excess_forecast_consecutive_low' : 'shortage_forecast_consecutive_high'));
const conditionKey = computed(() =>
  props.direction === 'excess' ? 'dashboard:アラート条件:nヶ月連続でm%以下' : 'dashboard:アラート条件:nヶ月連続でm%以上'
);
</script>
<template>
  <div class="alert-input-consecutive">
    <div class="label">{{ t(title) }}</div>
    <div>
      <I18nT :keypath="conditionKey" tag="span" class="alert-input-consecutive__condition">
        <template #n>
          <input
            key="consecutive-months"
            :value="consecutiveMonths"
            type="number"
            min="1"
            max="99"
            class="alert-input-consecutive__input alert-input-consecutive__input--percentage"
            @input="emits('update:consecutiveMonths', $event)"
            @keydown.e.prevent
          />
        </template>
        <template #m>
          <input
            key="ratio-threshold"
            :value="ratioThreshold"
            type="number"
            min="0"
            max="999"
            class="alert-input-consecutive__input alert-input-consecutive__input--percentage"
            @input="emits('update:ratioThreshold', $event)"
            @keydown.e.prevent
          />
        </template>
      </I18nT>
    </div>
    <div v-if="defaultValueString" class="default-value">
      {{ defaultValueString }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.alert-input-consecutive {
  display: grid;
  grid-template-rows: max-content;
  gap: 8px;
  padding: 8px;
  border-radius: 4px;

  *:not(.material-icons) {
    font-family: Noto Sans JP;
  }

  .label {
    font-weight: 700;
  }

  &__input {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    line-height: 1;
    &--percentage {
      width: 80px;
    }
    &--quantity {
      width: 94px;
    }
  }
}
.default-value {
  font-size: 13px;
  color: $textSecondary;
}
</style>
